// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/b210d4de/" + chunkId + "." + __webpack_require__.h() + ".vb210d4de.js";
};